import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useEffectiveMe } from '@/lib/effectiveMe';
import { canConfigureHaccp } from './haccpAccess';

export default function RequireHaccpAccess({ fallback = '/access-denied', children }) {
  const { loading } = useAuth();
  const me = useEffectiveMe();
  if (loading) return null;
  if (!me || !canConfigureHaccp(me)) return <Navigate to={fallback} replace />;
  return children;
}
